import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Header } from '~/components/header'
import { Sidebar } from '~/components/sidebar'
import { Table } from '~/components/table'
import * as route from '~/helper/constant/route'
import { AbstractAssetComponent, mapStateToProps } from './abstract'
import { Loading } from '~/components/loader'

class AssetViewComponent extends AbstractAssetComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }
    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Sidebar id="assets" isAccount={true} />
                <Loading status={this.state.loading} text={this.state.loading_text} />

                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.accounting.menu}>{t('sidebar:account')} &nbsp; &gt; &nbsp;</a>
                            </li>
                            <li>{t('doubleentry:assets')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-5 float-left">
                                <h5 className="main-title heading5">{t('doubleentry:assets')}</h5>
                            </div>
                            <div className="col-md-7 calendar-module float-left text-right">
                                <div className="display-inline-block">
                                    <a href={route.admin.accounting.asset.add} className="main-button">
                                        {t('common:addBtn')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="main-form">
                        <Table data={this.state.tableStructure} />
                        <br />
                    </div>
                </div>
            </div>
        )
    }
}
const AssetView = withTranslation()(connect(mapStateToProps)(AssetViewComponent))

export { AssetView }
